import { Box, CircularProgress, Typography } from '@mui/material';

export const ResultsAndMapLoading = () => (
  <Box
    sx={{
      width: '100%',
      height: '80vh',
      minHeight: '50vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        padding: 2,
        borderRadius: 1,
      }}
    >
      <CircularProgress />
      <Typography>Loading...</Typography>
    </Box>
  </Box>
);
